var _circle, _circle2, _path, _ellipse, _path2, _circle3, _circle4, _path3, _circle5, _g, _g2, _path4, _path5, _path6, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoloYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.812,
    y1: 3.1875,
    x2: 99.812,
    y2: 197.9145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3249,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4403,
    style: {
      stopColor: "#CDCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    style: {
      stopColor: "#D4D4D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6364,
    style: {
      stopColor: "#EBEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6718,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    style: {
      stopColor: "#CDCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7078,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7584,
    style: {
      stopColor: "#9A9A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    style: {
      stopColor: "#989898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9315,
    style: {
      stopColor: "#40403F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#212121"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    cx: 99.812,
    cy: 100.288,
    r: 97.101
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.812,
    y1: 6.5063,
    x2: 99.812,
    y2: 194.5782
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    style: {
      stopColor: "#C3C2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2037,
    style: {
      stopColor: "#B7B6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2815,
    style: {
      stopColor: "#DDDDDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3167,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3779,
    style: {
      stopColor: "#CFCECD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#BAB9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4588,
    style: {
      stopColor: "#B3B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4985,
    style: {
      stopColor: "#BAB9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    style: {
      stopColor: "#CFCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    style: {
      stopColor: "#CDCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7009,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7382,
    style: {
      stopColor: "#9A9A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    style: {
      stopColor: "#989898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    style: {
      stopColor: "#959595"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#7F7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8139,
    style: {
      stopColor: "#6C6B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8316,
    style: {
      stopColor: "#565554"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8491,
    style: {
      stopColor: "#3C3C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8662,
    style: {
      stopColor: "#1F1F1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8666,
    style: {
      stopColor: "#1E1E1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8787,
    style: {
      stopColor: "#2A2A2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9212,
    style: {
      stopColor: "#4D4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9571,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9844,
    style: {
      stopColor: "#7A7A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#818181"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_2_)",
    cx: 99.813,
    cy: 100.288,
    r: 93.782
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.812,
    y1: 6.1016,
    x2: 99.812,
    y2: 194.4761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M99.813,194.476c-12.715,0-25.05-2.489-36.662-7.402c-11.215-4.743-21.289-11.534-29.938-20.185 c-8.65-8.649-15.441-18.722-20.185-29.938c-4.911-11.612-7.402-23.946-7.402-36.662c0-12.715,2.491-25.05,7.402-36.662 c4.744-11.215,11.535-21.288,20.185-29.938c8.65-8.65,18.723-15.441,29.938-20.185c11.612-4.912,23.947-7.402,36.662-7.402 c12.715,0,25.05,2.49,36.662,7.402c11.216,4.743,21.289,11.535,29.938,20.185c8.649,8.65,15.441,18.723,20.185,29.938 c4.911,11.612,7.401,23.947,7.401,36.662c0,12.716-2.49,25.05-7.401,36.662c-4.743,11.217-11.535,21.289-20.185,29.938 c-8.649,8.65-18.723,15.441-29.938,20.185C124.862,191.986,112.527,194.476,99.813,194.476z M99.813,6.912 c-51.489,0-93.377,41.889-93.377,93.376c0,51.489,41.889,93.378,93.377,93.378c51.487,0,93.377-41.889,93.377-93.378 C193.189,48.8,151.3,6.912,99.813,6.912z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.812,
    y1: 22.2397,
    x2: 99.812,
    y2: 178.7589
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E5"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_4_)",
    cx: 99.813,
    cy: 100.288,
    rx: 79.179,
    ry: 78.049
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.813,178.742c-10.743,0-21.165-2.074-30.975-6.165c-9.478-3.95-17.988-9.606-25.298-16.813 c-7.309-7.204-13.047-15.595-17.055-24.937c-4.151-9.673-6.255-19.947-6.255-30.54c0-10.591,2.104-20.867,6.255-30.54 c4.008-9.342,9.746-17.732,17.055-24.937C50.85,37.607,59.36,31.95,68.837,28c9.811-4.091,20.232-6.166,30.975-6.166 s21.164,2.075,30.976,6.166c9.477,3.95,17.987,9.607,25.296,16.812c7.31,7.205,13.048,15.595,17.057,24.937 c4.151,9.673,6.256,19.948,6.256,30.54c0,10.593-2.104,20.867-6.256,30.54c-4.009,9.342-9.747,17.732-17.057,24.937 c-7.309,7.206-15.819,12.862-25.296,16.813C120.977,176.668,110.556,178.742,99.813,178.742z M99.813,22.645 c-43.435,0-78.773,34.831-78.773,77.644c0,42.813,35.338,77.645,78.773,77.645c43.436,0,78.773-34.831,78.773-77.645 C178.586,57.475,143.248,22.645,99.813,22.645z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 99.8125,
    cy: 100.2881,
    r: 73.9746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    style: {
      stopColor: "#EFE92F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1401,
    style: {
      stopColor: "#E2DB30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    style: {
      stopColor: "#C8C131"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5568,
    style: {
      stopColor: "#A39B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8017,
    style: {
      stopColor: "#767029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#544F20"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_5_)",
    cx: 99.813,
    cy: 100.288,
    r: 73.975
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 99.8125,
    cy: 100.2881,
    r: 73.9746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.4e-7,
    style: {
      stopColor: "#EFE92F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1401,
    style: {
      stopColor: "#E2DB30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3331,
    style: {
      stopColor: "#C8C131"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5568,
    style: {
      stopColor: "#A39B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8017,
    style: {
      stopColor: "#767029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#544F20"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_6_)",
    cx: 99.813,
    cy: 100.288,
    r: 73.975
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.8198,
    y1: 3.2031,
    x2: 99.8198,
    y2: 89.7246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    fill: "url(#SVGID_7_)",
    d: "M167.724,30.898C150.217,13.766,126.253,3.203,99.821,3.203 c-26.433,0-50.396,10.563-67.904,27.695c-3.993,5.718-6.209,12.035-6.209,18.678c0,25.707,33.182,40.148,74.113,40.148 c40.93,0,74.112-14.441,74.112-40.148C173.933,42.933,171.717,36.616,167.724,30.898z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.8198,
    y1: 3.2031,
    x2: 99.8198,
    y2: 225.0346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6491,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6967,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7772,
    style: {
      stopColor: "#CDCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    style: {
      stopColor: "#B0B0B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8482,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8815,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9129,
    style: {
      stopColor: "#323232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9411,
    style: {
      stopColor: "#010101"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    display: "none",
    fill: "url(#SVGID_8_)",
    cx: 99.82,
    cy: 100.296,
    r: 97.093
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M166.54,88.774c4.028,22.987,11.743,30.812,1.118,49.672c-4.719,8.377-11.641,5.487-17.525,6.617 c-11.312,2.174-23.658,2.106-43.28,5.545c-25.064,4.391-44.698,13.043-62.058,11.715c-4.21-0.323-9.166,3.956-12.228,5.006 c-1.415,0.486-2.814,0.195-2.129,0.9c-13.276-13.535-22.734-31.091-26.253-51.177C-5.07,64.234,30.247,13.914,83.065,4.66 c27.721-4.856,54.755,2.564,75.524,18.348c0.337,0.257-1.016,0.632-0.961,1.041C159.566,38.207,162.223,64.127,166.54,88.774z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.110995e-006 3.121328e-006)",
    clipPath: "url(#SVGID_10_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 1221,
    height: 1105,
    xlinkHref: "1585ACF6.png",
    transform: "matrix(0.24 0 0 0.24 -114.5649 -78.5508)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.813,166.916c-8.993,0-17.72-1.763-25.935-5.237c-7.935-3.355-15.06-8.159-21.178-14.277 s-10.922-13.244-14.278-21.178c-3.474-8.216-5.237-16.942-5.237-25.936s1.763-17.719,5.237-25.935 c3.356-7.935,8.16-15.059,14.278-21.178c6.118-6.118,13.244-10.921,21.178-14.277c8.215-3.475,16.941-5.237,25.935-5.237 s17.72,1.762,25.935,5.237c7.935,3.356,15.061,8.159,21.178,14.277c6.119,6.119,10.922,13.244,14.278,21.178 c3.475,8.216,5.237,16.941,5.237,25.935s-1.763,17.72-5.237,25.936c-3.356,7.934-8.159,15.06-14.278,21.178 c-6.117,6.118-13.243,10.922-21.178,14.277C117.532,165.153,108.806,166.916,99.813,166.916z M99.813,38.393 c-34.13,0-61.896,27.766-61.896,61.896c0,34.13,27.766,61.896,61.896,61.896s61.896-27.767,61.896-61.896 C161.708,66.159,133.942,38.393,99.813,38.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M148.05,142.747c-11.775,13.368-29.021,21.803-48.237,21.803c-19.216,0-36.46-8.435-48.237-21.803 c2.502-15.541,12.33-28.629,25.831-35.607c1.115,1.058,2.303,2.035,3.554,2.924c5.533,3.923,12.052,5.999,18.853,5.999 c6.8,0,13.318-2.076,18.851-5.999c1.253-0.889,2.441-1.867,3.557-2.924C135.72,114.118,145.548,127.206,148.05,142.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.852,83.451c0,8.438-4.173,15.9-10.567,20.438c-4.086,2.898-9.08,4.602-14.472,4.602 s-10.384-1.703-14.471-4.602c-6.396-4.537-10.569-12-10.569-20.438c0-13.829,11.211-25.041,25.041-25.041 S124.852,69.622,124.852,83.451z"
  })))))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fill: "#231F20",
    d: "M117.133,28.288c12.753,13.301,20.591,31.352,20.591,51.233 c0,40.891-33.15,74.041-74.041,74.041c-5.964,0-11.763-0.706-17.319-2.038c13.476,14.055,32.44,22.805,53.448,22.805 c40.891,0,74.04-33.149,74.04-74.04C173.853,65.363,149.668,36.084,117.133,28.288z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 99.813,
    cy: 100.2886,
    r: 74.0406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333333"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fill: "url(#SVGID_11_)",
    d: "M137.724,79.521c0-19.881-7.838-37.932-20.591-51.233 c-4.78-1.145-9.741-1.828-14.832-1.996c-0.826-0.031-1.655-0.044-2.488-0.044c-40.89,0-74.04,33.15-74.04,74.04 c0,16.918,5.674,32.511,15.224,44.979c1.673,2.186,3.466,4.273,5.368,6.256c5.556,1.332,11.354,2.038,17.319,2.038 C104.573,153.562,137.724,120.411,137.724,79.521z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fill: "#FFFFFF",
    d: "M153.016,67.937c0,16.414-23.819,29.72-53.203,29.72s-53.204-13.306-53.204-29.72 c0-16.415,23.82-38.715,53.204-38.715S153.016,51.521,153.016,67.937z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.813,166.916c-8.993,0-17.72-1.763-25.935-5.237c-7.935-3.355-15.06-8.159-21.178-14.277 s-10.922-13.244-14.278-21.178c-3.474-8.216-5.237-16.942-5.237-25.936s1.763-17.719,5.237-25.935 c3.356-7.935,8.16-15.059,14.278-21.178c6.118-6.118,13.244-10.921,21.178-14.277c8.215-3.475,16.941-5.237,25.935-5.237 s17.72,1.762,25.935,5.237c7.935,3.356,15.061,8.159,21.178,14.277c6.119,6.119,10.922,13.244,14.278,21.178 c3.475,8.216,5.237,16.941,5.237,25.935s-1.763,17.72-5.237,25.936c-3.356,7.934-8.159,15.06-14.278,21.178 c-6.117,6.118-13.243,10.922-21.178,14.277C117.532,165.153,108.806,166.916,99.813,166.916z M99.813,38.393 c-34.13,0-61.896,27.766-61.896,61.896c0,34.13,27.766,61.896,61.896,61.896s61.896-27.767,61.896-61.896 C161.708,66.159,133.942,38.393,99.813,38.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M148.05,142.747c-11.775,13.368-29.021,21.803-48.237,21.803c-19.216,0-36.46-8.435-48.237-21.803 c2.502-15.541,12.33-28.629,25.831-35.607c1.115,1.058,2.303,2.035,3.554,2.924c5.533,3.923,12.052,5.999,18.853,5.999 c6.8,0,13.318-2.076,18.851-5.999c1.253-0.889,2.441-1.867,3.557-2.924C135.72,114.118,145.548,127.206,148.05,142.747z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.852,83.451c0,8.438-4.173,15.9-10.567,20.438c-4.086,2.898-9.08,4.602-14.472,4.602 s-10.384-1.703-14.471-4.602c-6.396-4.537-10.569-12-10.569-20.438c0-13.829,11.211-25.041,25.041-25.041 S124.852,69.622,124.852,83.451z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoloYellow);
export default __webpack_public_path__ + "static/media/soloYellow.2bbaaac0e57466a7cd830caf243b8a8b.svg";
export { ForwardRef as ReactComponent };